<div class="card no-margin">
    <div class="table-responsive text-center justify-content-center" style="
        font-size: 14px;
        margin-bottom: 20px;
        text-align: center;
        vertical-align: center;
      ">
        <p-table #dt1 [value]="certificate_data" dataKey="id" styleClass="p-datatable-customers" [rows]="10"
            [paginator]="true" [showCurrentPageReport]="true" [scrollable]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="[10, 25, 50]" [globalFilterFields]="[
          'document_name', 'document_url', 'expires_on']">
            <ng-template pTemplate="caption">
                <div class="table-header float-right">
                    <span class="p-input-icon-left">
                        <input pInputText type="text" (input)="dt1.filterGlobal($event.target.value, 'contains')"
                            placeholder="Search" />
                    </span>
                </div>
            </ng-template>

            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="document_name">
                        <b>Certificate Name</b>
                        <p-sortIcon field="document_name"></p-sortIcon>
                    </th>
                    <th pSortableColumn="document_url">
                        <b>View Certificate</b>
                        <p-sortIcon field="document_url"></p-sortIcon>
                    </th>
                    <th pSortableColumn="expires_on">
                        <b>Expiry Date</b>
                        <p-sortIcon field="expires_on"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-certificate_data>
                <tr [pSelectableRow]="certificate_data">
                    <td class="notranslate">
                        {{ certificate_data.document_name }}
                    </td>
                    <td class="notranslate">
                        <button pButton type="button" label="Download" icon="pi pi-download"
                            class="p-button-sm p-button-outlined"
                            (click)="downloadBase64PDF(certificate_data.document_url)">
                        </button>
                    </td>
                    <td>
                        <span>{{ certificate_data.expires_on | date: 'medium' }}</span>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="10">No Data found.</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft"> </ng-template>
            <ng-template pTemplate="paginatorright"> </ng-template>
        </p-table>
    </div>
</div>